import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";

import * as validations from "../../system/utils/Validation";
import Wysiwyg from "../../system/fields/Wysiwyg";

import { getCities } from "../../store/overview";

class EditForm extends Component {
  componentDidMount() {
    this.props.dispatch(getCities());
  }

  render() {
    const { props } = this;
    const { handleSubmit, mode } = props;
    console.log(props.destinations);
    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <section className="form-section">
            <div className={"row"}>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Name</Label>
                <Field
                  name={"name"}
                  component={TextInput}
                  type={"text"}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Destination</Label>
                <Field
                  name={"destination"}
                  component={SelectDropdown}
                  labelKey={"label"}
                  valueKey={"id"}
                  options={props.destinations}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Price (£)</Label>
                <Field
                  name={"price"}
                  component={TextInput}
                  type={"number"}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12"}>
                <Label>Image</Label>
                <p className="instruction">Image must be 1920 x 1080 or bigger in the same aspect ratio</p>
                <Field
                  name={"image"}
                  component={FileUpload}
                  multiple={false}
                  validate={validations.required}
                />
              </FormGroup>
              <FormGroup className={"col-12"}>
                <Label>Summary</Label>
                <Field
                  name={"summary"}
                  component={Wysiwyg}
                  type={"text"}
                  validate={validations.required}
                />
              </FormGroup>
            </div>
          </section>
        </Form>

        {props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "ExcursionForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("ExcursionForm"));
    }
  }
})(EditForm);

const mapStateToProps = state => ({
  destinations: state.overview.cities
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Excursions/Form.jsx